<section class="ChargerLookupLanding u-spacing-2xl-pt">
    <div class="ChargerLookupLanding-intro u-spacing-xl-mb">
        <h2 class="ChargerLookupLanding-title u-text-title-lg u-color-text-primary u-spacing-sm-mb">
            Charger event log
        </h2>
        <p class="ChargerLookupLanding-description u-text-body-md u-color-text-secondary">
            Retrieve the CTEP-compliant event log for a charger. Enter the charger identifier to continue.
        </p>
    </div>

    <form
        [formGroup]="form"
        (ngSubmit)="onSubmit()"
        class="ChargerLookupLanding-form"
        novalidate
        data-testid="charger-lookup-form"
    >
        <ce-form-field class="ChargerLookupLanding-field">
            <label ce-input-label for="chargerId" class="u-text-label-sm">Charger identifier</label>
            <input
                ce-input
                id="chargerId"
                type="text"
                autocomplete="off"
                spellcheck="false"
                placeholder="e.g. serial number"
                [formControl]="chargerIdControl"
                data-testid="charger-id-input"
            />
            @if (chargerIdControl.touched && chargerIdControl.errors?.['required']) {
                <span ce-input-error>cannot be empty</span>
            } @else if (chargerIdControl.touched && chargerIdControl.errors?.['minlength']) {
                <span ce-input-error>must be at least 3 characters</span>
            }
        </ce-form-field>

        <button
            ce-button-large
            ce-button-type-primary
            class="ChargerLookupLanding-submit u-spacing-md-mt"
            data-testid="charger-lookup-submit"
        >
            View event log
        </button>
    </form>
</section>
